<script>
	export let classes = 'opacity-50';
</script>

<svg
	class={classes}
	viewBox="0 0 1920 1080"
	xmlns="http://www.w3.org/2000/svg"
	fill-rule="evenodd"
	clip-rule="evenodd"
	stroke-linejoin="round"
	stroke-miterlimit="2">
	<g fill="currentColor" fill-rule="nonzero">
		<path
			d="M1428.624 603.239l-140.421-223.713h51.847L1191.292 143.37l-148.758 236.155h51.835L960.17 593.35l-134.2-213.824h51.835L729.046 143.37 580.288 379.526h51.847l-140.42 223.713h51.784L397.307 837.316H668.75v99.05h120.594v-99.088h341.652v99.051h120.594v-99.05h271.442L1376.839 603.2l51.785.038zm-514.019 0h91.14L960.17 676.19l-45.564-72.952zM286.277 227.225L52.65 460.852l64.903 64.903 168.724 168.736 64.903-64.903-168.736-168.736L351.18 292.13l-64.903-64.904zM1802.785 395.961L1634.06 227.225l-64.903 64.904 168.736 168.723-168.736 168.736 64.903 64.903 168.724-168.736 64.903-64.903-64.903-64.89z" />
	</g>
</svg>
